import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription, TimeoutError, catchError, map, throwError, timeout } from 'rxjs';
import { Component, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';

// enums
import { User } from 'src/app/core/enums/user/info-user';
import { agencyType } from 'src/app/core/enums/user/agency-type';
import { CREATION_TYPE } from 'src/app/core/enums/ads/creation-types';
import { CRUD_COMPONENT } from 'src/app/core/enums/global/crud-types';
import { RANDOM_VALUE } from 'src/app/core/enums/global/random-value';
import { LAYOUTS_TYPE } from 'src/app/core/enums/layouts/layouts-types';
import { AD_NUMBER_LIMIT } from 'src/app/core/enums/form/controls/adNumber-limit';
import { CATEGOR_VALUE_TYPE } from 'src/app/core/enums/category/cate-value-types';

// interfaces
import { IRega } from 'src/app/core/interfaces/ads/rega';
import { IUserInfo  } from 'src/app/core/interfaces/user/user-info';

// services
import { GlobleService } from 'src/app/core/services/globle.service';
import { AlertService } from 'src/app/core/services/alert/alert.service';
import { ApiResponseService } from 'src/app/core/services/handel-api-response/api-response.service';

// validations
import OverrideValidators from 'src/app/core/validations/validators-override/validators-override';

@Component({
  selector: 'app-advertiser-class',
  templateUrl: './advertiser-class.component.html',
  styleUrls: ['./advertiser-class.component.scss'],
})
export class AdvertiserClassComponent implements OnInit, OnDestroy {


  //
  @Output() useClose = new EventEmitter<void>()
  @Output() useSubmit = new EventEmitter<IRega | CATEGOR_VALUE_TYPE>()

  // enums
  private creationType: CREATION_TYPE = CREATION_TYPE.Rega
  //
  public CREATION_TYPE = CREATION_TYPE
  public CRUD_COMPONENT = CRUD_COMPONENT

  // boolean
  private isLoading: boolean = false;

  // Array
  private errorsMsg: {msg: string}[] = []
  //
  public listOfBundledAds: {title: string, type: CATEGOR_VALUE_TYPE}[] = [
    { type: CATEGOR_VALUE_TYPE.BL, title: 'اضافة عمارة وتوزيع الوحدات حسب الطوابق' },
    { type: CATEGOR_VALUE_TYPE.PL, title: 'اضافة مخطط وتوزيع الاراضي حسب المخطط' },
    { type: CATEGOR_VALUE_TYPE.VL, title: 'اضافة مجمع فلل وتوزيع الفلل بداخل المجمع' },
    { type: CATEGOR_VALUE_TYPE.OFF_PLAN, title: 'اضافه مشروع بيع على الخارطه' },
  ]

  //
  private form: FormGroup
  private regaValue: IRega = null
  private subscription: Subscription
  private bundledAdsType: CATEGOR_VALUE_TYPE

  constructor(
    private FB: FormBuilder,
    private G: GlobleService,
    private Alert: AlertService,
    public route: ActivatedRoute,
    private API_RESPONSE: ApiResponseService,
  ) {}

  ngOnInit(): void {
    
    //
    const { 
      curd,
      ads = {},
      ads: { 
        owner: {
          idNumber = ''
        } = {},
        adNumber = '',
        advertiserClass = '' ,
      } = {}
    } = this.route.snapshot.data;
    
    //
    

    //
    this.form = this.FB.group({
      
      idType: [
        this.UserDefinitions.idType,
        OverrideValidators.required
      ],
      idNumber: [this.UserDefinitions.idNumber, [
          OverrideValidators.required,
          OverrideValidators.minlength(AD_NUMBER_LIMIT.min),
          OverrideValidators.maxlength(AD_NUMBER_LIMIT.max)
        ]
      ],
      adNumber: [null, [
          OverrideValidators.required,
          OverrideValidators.minlength(AD_NUMBER_LIMIT.min),
          OverrideValidators.maxlength(AD_NUMBER_LIMIT.max)
        ]
      ],
    })

    //
    if (this.Form.get('idNumber').value) this.Form.get('idNumber').disable() 

    //
    if (curd == CRUD_COMPONENT.update) {

      // //
      if (adNumber) {

        //
        this.Form.patchValue({adNumber})
        
        //
        this.BtnHandle()
        
      }
      

    }      


  }

  // getters

    //
    private get UserInfo(): IUserInfo  {
      return this.G.getUserData(User.info)
    }

    // Form
      public get Form(): FormGroup {
        return this.form
      }
    // Form

    //
    public get UserDefinitions() {

      if ((this.UserInfo?.parentAgencyType || this.UserInfo?.agencyType) == agencyType.freeWork) return {
        idType: '1',
        title: 'رقم الهوية',
        idNumber: this.UserInfo.idNumber
      }

      return {
        idType: '2',
        title: 'الرقم الموحد للمنشاة',
        idNumber: this.UserInfo.licenseNumber
      }

    }

    //
    public get IsLoading(): boolean {
      return this.isLoading
    }

    public set IsLoading(value: boolean) {
      this.isLoading = value
    }

    //
    public get ErrorsMsg(): {msg: string}[] {
      return this.errorsMsg
    }

    public set ErrorsMsg(arr: {msg: string}[]) {
      this.errorsMsg = arr
    }        

    // creationType
      public get CreationType(): CREATION_TYPE {
        return this.creationType
      }

      public set CreationType(value: CREATION_TYPE) {
        this.creationType = value
      }
    // creationType

    // bundledAdsType
      public get BundledAdsType(): CATEGOR_VALUE_TYPE {
        return this.bundledAdsType
      }

      public set BundledAdsType(value: CATEGOR_VALUE_TYPE) {
        this.bundledAdsType = value
      }    
    // bundledAdsType

    // RegaValue
      public get RegaValue(): IRega {
        return this.regaValue
      }

      private set RegaValue(value: IRega) {
        this.regaValue = value
      }
    // RegaValue
  
    // Btn
      public get disableBtn(): boolean {

        if (this.CreationType == CREATION_TYPE.Rega && this.Form.valid) return false
        else if (this.CreationType != CREATION_TYPE.Rega && this.BundledAdsType) false
        else return true
        
      }

      public get BtnTitle(): string {
        
        if (this.RegaValue) return 'تاكيد'
        
        switch(this.CreationType) {
          case CREATION_TYPE.Rega:
            return 'بحث عن العقار'
          default:
            return 'متابعة'
        }

      }
      public get BtnHandle() {
        
        //
        switch(this.CreationType) {
          case CREATION_TYPE.Rega:
            if (this.RegaValue) return this.exportValue.bind(this)
            return this.Submit.bind(this)
          default:
            return this.exportValue.bind(this)
        }    
  
      }
    // Btn

  // getters

  // methods
    public selectCreationType(value: CREATION_TYPE): void {

      if (this.CreationType != value) {
        this.CreationType = value;
      }

    }

    public selectBundleAdsType(value: CATEGOR_VALUE_TYPE): void {

      if (this.BundledAdsType != value) {
        this.BundledAdsType = value;
      }
      
    }

    private exportValue(): void {
      this.Close.bind(this)();

      if (this.RegaValue || this.BundledAdsType) {
        this.useSubmit.emit(this.RegaValue ? this.RegaValue : this.BundledAdsType);
      }

    }

    private Close(): void {
      this.useClose.emit()
    }

    public Submit(): void {

      // ES6 Destructing
      const { curd } = this.route.snapshot.data;

      if (this.CreationType == CREATION_TYPE.Rega) {

        /**
         * Start loading
         */
        this.IsLoading = true

        /**
         * reset Rega Data
         */
        this.RegaValue = null

        /**
         * rest errors
         */
        this.ErrorsMsg = []

        //
        const params = {};

        if (curd != CRUD_COMPONENT.update) {
          params[RANDOM_VALUE.loader] = false
        }

        this.subscription = this.API_RESPONSE.regaGetData(
          this.Form.getRawValue(),
          { params }
        ).pipe(
          map(res => {

            // ES6 Destructing
            const { isValid, advertisement } = res || {};    
            
            if (isValid && advertisement) return res
            else throw new Error('Invalid response')

          }),
          timeout(1000 * 10),
          catchError(error => {
            // Handle the error here
            // console.error('Error occurred:', error);
            // You can also re-throw the error if needed
            if (error instanceof Error && error?.message == 'Invalid response') {
              return throwError({error: { errors: [{ msg: 'رقم الاعلان غير صحيح او غير موجود' }] }});
            }
            return throwError(error);
          })          
        ).subscribe(
          res => {

            // ES6 Destructing
            const { isValid, advertisement } = res || {};
            const { value, value: { adNumber } } = this.Form || {}

            if (isValid  && advertisement) {
              // ES6 spread operator
              this.RegaValue = { isValid, ...advertisement, ...this.Form.getRawValue()};
              /**
               * only in CRUD_COMPONENT.update mode
               */
              if (curd == CRUD_COMPONENT.update) this.BtnHandle()
            }
            /**
             * stop loading
             */
            this.IsLoading = false;

          },
          err => {
            if (err instanceof TimeoutError && curd == CRUD_COMPONENT.create) {
              /**
               * show in CRUD_COMPONENT.create only
               */
              this.ErrorsMsg = [{ msg: 'خطاء من جهة بيانات الهيئة يمكنك المتابعة في وقت اخر' }]
            }            
            else if (err instanceof TimeoutError || curd == CRUD_COMPONENT.update) {

              // fire 
              this.exportValue()
              //
              this.Alert.show({
                titleBtn: 'متابعة',
                type: LAYOUTS_TYPE.alertFailure,
                msg: 'خطاء من جهة بيانات الهيئة, في حالة حدوث هذا الخطاء نتيح لك تعديل البيانات يدويا'
              })

            }
            else {
  
              // ES6 Destructing
              const { errors } = err.error || {};
  
              //
              this.ErrorsMsg = errors;

            }

            // stop loading
            this.IsLoading = false;

          }
        )

      }
    }
  // methods

  ngOnDestroy(): void {
    if (this.subscription) this.subscription.unsubscribe()
  }

}
